import { PageLayout, PageLayoutHeader, PageLayoutRow, PageLayoutTitle } from 'components';
import React from 'react';
import { Link } from 'react-router-dom';
import * as S from '../app.styles';

export class NotFound extends React.PureComponent {
    public render(): React.ReactElement {
        return (
            <S.Section>
                <PageLayout>
                    <PageLayoutRow>
                        <PageLayoutHeader>
                            <PageLayoutTitle>404 Page Not Found</PageLayoutTitle>
                        </PageLayoutHeader>
                    </PageLayoutRow>
                    <PageLayoutRow>
                        <Link to="/">
                            <S.Button>Return to Dashboard</S.Button>
                        </Link>
                    </PageLayoutRow>
                </PageLayout>
            </S.Section>
        );
    }
}
